import styled from "@emotion/styled";
import { FONT_SIZES } from "../../../../../../../../../emotion-theme";

export const FlyerDetailPagePreviewPositionCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  flex-direction: column;
`;
export const FlyerDetailPageDetailPositionLabel = styled.h1`
  font-size: ${FONT_SIZES.large};
  text-align: center;
  vertical-align: middle;
  margin: 4px 0 4px 0;
`;
